import { Request } from '../request';
import type { ETextVisitProviderApproveStatus, TTextVisitCaseListParams, TTextVisitProviderListParams } from 'types/textVisitCase';

// 获取病例列表
export const getTextVisitCaseList = (params: TTextVisitCaseListParams) =>
    Request.post<TTextVisitCaseListParams>({
        url: '/admin-server/text/visit/list',
        params,
    });

// 获取病例详情
export const getTextVisitCaseDetail = (textVisitUuid: string) =>
    Request.get({
        url: `/admin-server/text/visit/detail/${textVisitUuid}`,
    });

export const getTextVisitProviderList = (params: TTextVisitProviderListParams) =>
    Request.post({
        url: '/admin-server/text/visit/provider/list',
        params,
    });

export const updateProviderTextVisitStatus = (providerId: number, status: ETextVisitProviderApproveStatus) =>
    Request.post({
        url: '/admin-server/text/visit/provider/status/update',
        params: {
            providerId,
            status,
        },
    });
